import { FormattedMessage } from 'react-intl';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import { Form } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { SettingsIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';

import {
  useCreateAffordableWaitlistPropertyPreferences,
  useUpdateAffordableWaitlistPropertyPreferences,
} from '../../ManageAffordableWaitlist/hooks.affordableWaitlistPropertyPreferencesMutations';
import { propertyPreferencesNames } from '../../ManageAffordableWaitlist/ManageAffordableWaitlistModals/constants';
import modalMessages from '../../ManageAffordableWaitlist/ManageAffordableWaitlistModals/messages';
import affordableWaitlistMessages from '../../ManageAffordableWaitlist/messages';
import useReactHookFormProps from '../../../hooks/useReactHookFormProps';

export const getPreferencesPayload = (values) =>
  Object.keys(values).filter((key) => values[key]);

const ConfigurePreferences = ({
  organizationId,
  propertyId,
  open,
  handleClose,
  defaultValues,
  refetchPreferences,
}) => {
  const ReactHookFormProps = useReactHookFormProps({
    defaultValues: defaultValues.options,
    mode: 'onChange',
  });
  const { getValues, isValid, isDirty, reset } = ReactHookFormProps;

  const { mutate: createMutate, isLoading: isCreating } =
    useCreateAffordableWaitlistPropertyPreferences({
      organizationId,
      propertyId,
      options: {
        onSuccess: (res) => {
          toastr.success('Success', res.message);
          reset(defaultValues.options);
          refetchPreferences();
          handleClose();
        },
        onError: (e) => toastr.error('Error', e),
      },
    });

  const { mutate: updateMutate, isLoading: isUpdating } =
    useUpdateAffordableWaitlistPropertyPreferences({
      organizationId,
      propertyId,
      options: {
        onSuccess: (res) => {
          toastr.success('Success', res.message);
          reset(defaultValues.options);
          refetchPreferences();
          handleClose();
        },
        onError: (e) => toastr.error('Error', e),
      },
    });

  const formProps = {
    fields: [
      {
        name: 'custom',
        variant: 'custom',
        component: (
          <Typography variant="titleMedium" marginBottom={2} display="block">
            <FormattedMessage {...modalMessages.preferences} />
          </Typography>
        ),
        GridProps: { xs: 12 },
      },
      ...propertyPreferencesNames.map((name) => ({
        variant: 'checkbox',
        name: _.camelCase(name),
        label: <FormattedMessage {...modalMessages[_.camelCase(name)]} />,
        GridProps: {
          xs: 12,
          sx: { '& .MuiFormControlLabel-label': { marginLeft: '6px' } },
        },
      })),
    ],
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={
        <Typography variant="titleLarge">
          <FormattedMessage
            {...affordableWaitlistMessages.configurePreferences}
          />
        </Typography>
      }
      icon={<SettingsIcon />}
      ModalProps={{ PaperProps: { sx: { height: 625 } } }}
      actionsProps={[
        { children: 'Cancel', onClick: handleClose },
        {
          children: <FormattedMessage {...modalMessages.save} />,
          submitButton: true,
          isSubmitting: isCreating || isUpdating,
          disabled: !isValid || !isDirty,
          onClick: () => {
            const payload = { preferences: getPreferencesPayload(getValues()) };
            if (defaultValues.id) {
              updateMutate({ payload });
            } else {
              createMutate({ payload });
            }
          },
        },
      ]}
    >
      <Form ReactHookFormProps={ReactHookFormProps} {...formProps} />
    </Modal>
  );
};

export default ConfigurePreferences;
